'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.selectLanguageKey = exports.selectLanguageDir = exports.selectLanguage = exports.selectLanguageList = exports.selectTranslationList = exports.selectDefaultLanguageKey = exports.selectModule = undefined;

var _constants = require('../constants');

function selectModule(state) {
    return state[_constants.MODULE_NAME];
}

function selectDefaultLanguageKey(state) {
    return selectModule(state).defaultLanguageKey;
}

function selectLanguageKey(state) {
    return selectModule(state).languageKey;
}

function selectLanguageList(state) {
    return selectModule(state).languageList;
}

function selectLanguage(state, key) {
    var list = selectLanguageList(state);
    return list[key];
}

function selectLanguageDir(state, key) {
    var language = selectLanguage(state, key);
    return language && language.dir;
}

function selectTranslationList(state) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : selectLanguageKey(state);

    if (!key) {
        return {};
    }
    return selectModule(state).messages[key];
}

exports.selectModule = selectModule;
exports.selectDefaultLanguageKey = selectDefaultLanguageKey;
exports.selectTranslationList = selectTranslationList;
exports.selectLanguageList = selectLanguageList;
exports.selectLanguage = selectLanguage;
exports.selectLanguageDir = selectLanguageDir;
exports.selectLanguageKey = selectLanguageKey;